import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./FanStar.css";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import NodataAvailable from "../../../../../Common/NodataAvailable";
import { serverInfo } from "../../../../../../App";

const FanExploreMore = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [fanList, setFanList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user/fan/group/list`).then((res) => {
        if (res.data.status === 200) {
          setFanList(res?.data?.fanList);
          setLoading(false);
        }
      });
  }, []);

  return (
    <>
      <div className="row mx-1 justify-content-between ">
        {loading ? (
          <>
            <h2 className="my-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
              Other Fan Group
            </h2>
            <SkeletonTheme baseColor="#202020" highlightColor="#444">
              <div className="row">
                {[1, 2].map((data) => (
                  <div className="col-md-6 mb-4 ">
                    <div className="rounded">
                      <div className="bg-dark py-3 px-2">
                        <Skeleton width="100%" height={150} />
                        <Skeleton width="20%" height={15} />
                        <Skeleton width="100%" className="" height={25} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </SkeletonTheme>
          </>
        ) : (
          <>
            {fanList.length === 0 ? null : (
              <>
                <h2 className="my-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
                  Other Fan Group
                </h2>
                {fanList?.map((fan, index) => (
                  <>
                    <div className="YourGroups col-md-6 pb-3">
                      <img
                        src={imageCdnUrl + fan?.banner}
                        className="YoursImg img-fluid"
                        alt=""
                      />

                      <Link to={`group/${fan?.id}`}>
                        <div
                          className={`d-flex justify-content-center ${
                            index % 2 === 0 ? "bg-danger" : "bg-success"
                          } p-3`}
                        >
                          <div className="celebratePerallal text-dark">
                            {fan?.group_name}
                          </div>
                        </div>
                      </Link>
                    </div>
                  </>
                ))}
              </>
            )}
          </>
        )}

        {/* )} */}
      </div>
    </>
  );
};

export default FanExploreMore;
